export default __webpack_public_path__ + "static/media/RobotExpressive.06f9d5cf.glb";